/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const unitOrder = {
  unitLevelOrderHistory: {
    orderHistory: 'Histórico de pedidos no nível da unidade',
    orderId: 'Ordem #',
    emptyPurchaseOrderId: 'Nenhum',
    date: 'Dados',
    status: 'Estado',
    buyer: 'Comprador',
    unit: 'Unidade',
    total: 'Total',
    noOrders: 'Não temos registros de pedidos correspondentes para sua unidade.',
    startShopping: 'Comece a comprar',
    sortBy: 'Classificar por',
    sortOrders: 'Critérios de classificação',
    purchaseOrderNumber: 'DEPOIS #',
    startOn: 'Inicie o',
    frequency: 'Frequência',
    nextOrderDados: 'Dados do próximo pedido',
    notFound: 'Nenhum pedido encontrado',
    //--------------------
    applyFilter: 'Aplicar',
    filterBy: 'Filtrar por',
    filterByComprador: 'Filtrar por comprador',
    filterByCompradorLabel: 'Nome do comprador',
    filterByCompradorPlaceholder: 'Digite o nome do comprador',
    filterByCompradorAriaLabel: 'Lista de filtros por comprador',
    filterByUnidade: 'Filtrar por Unidade',
    filterByUnidadeLabel: 'Cliente',
    filterByUnidadePlaceholder: 'Digite o nome da unidade',
    filterByUnidadeAriaLabel: 'Lista de filtros por unidade',
    search: 'Achar',
    clearAll: 'Apagar tudo',
    removeAppliedFilters: 'Remover filtros',
    yourFilters: 'Seus filtros:',
    and: ' e ',
  },
  unitLevelOrderHistorySorting: {
    date: 'Dados',
    orderNumber: 'Número do pedido',
    buyer: 'Comprador (Crescente)',
    buyerDesc: 'Comprador (Descendente)',
    orgUnidade: 'Unidade (Ascending)',
    orgUnidadeDesc: 'Unidade (Descending)',
  },
  unitLevelOrderDetails: {
    buyer: 'Comprador',
  },
};
